import React from 'react';
import Alert from '@mui/material/Alert';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { SectionCard } from '../../../components/Section';
import { PlanRulesGroup } from '../../../types/planRules';

interface UnassignedProductsProps {
  products: Array<{ id: number; name: string }>;
  groups: PlanRulesGroup[];
  onMoveProduct: (productTypeId: number, groupId: number) => void;
}

/** Products in no group have no plan rules: open to everyone with no limits. */
export function UnassignedProducts({ products, groups, onMoveProduct }: UnassignedProductsProps) {
  return (
    <SectionCard title="Products without a group" description="These products have no plan rules.">
      {products.length ? (
        <>
          <Alert severity="warning" sx={{ mb: '16px' }}>
            <strong>
              {products.length} product{products.length === 1 ? '' : 's'} open to everyone with no limits.
            </strong>{' '}
            Free users can open as many as they want. Add each one to a group.
          </Alert>
          <Table size="small" aria-label="Products without a group">
            <TableHead>
              <TableRow>
                <TableCell>Product</TableCell>
                <TableCell>Add to a group</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {products.map((product) => (
                <TableRow key={product.id}>
                  <TableCell sx={{ fontWeight: 600 }}>{product.name}</TableCell>
                  <TableCell>
                    <Select
                      size="small"
                      displayEmpty
                      value=""
                      renderValue={() => 'Choose a group…'}
                      onChange={(event) => onMoveProduct(product.id, Number(event.target.value))}
                      inputProps={{ 'aria-label': `Add ${product.name} to a group` }}
                      sx={{ minWidth: 200 }}
                    >
                      {groups.map((group) => (
                        <MenuItem key={group.id} value={group.id}>
                          {group.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </>
      ) : (
        <Alert severity="success">Every product is in a group.</Alert>
      )}
    </SectionCard>
  );
}
